{
  "auth": {
    "agree": "Я согласен",
    "createAccount": "Создать аккаунт",
    "createNewAccount": "Создать новый аккаунт",
    "email": "Почта",
    "login": "Логин",
    "password": "Пароль",
    "recover_password": "Восстановить пароль",
    "sign_up": "Зарегистрироваться",
    "keep_logged_in": "Keep me logged in",
    "termsOfUse": "Правила использования",
    "reset_password": "Сбросить пароль"
  },
  "404": {
    "title": "Страница не найдена",
    "text": "Если вы считаете, что это неправильно, пожалуйста, отправьте нам сообщение по адресу ",
    "back_button": "Вернуться на главную"
  },
  "typography": {
    "primary": "Стили основного текста",
    "secondary": "Дополнительные стили текста"
  },
  "dashboard": {
    "versions": "Версии",
    "setupRemoteConnections": "Настройка удаленных подключений",
    "currentVisitors": "Текущие посетители",
    "navigationLayout": "навигационный макет",
    "topBarButton": "Верхняя панель",
    "sideBarButton": "Боковая панель"
  },
  "menu": {
    "auth": "Аутентификация",
    "buttons": "Кнопки",
    "timelines": "Временные рамки",
    "dashboard": "Главная панель",
    "billing": "Счета",
    "login": "Выйти",
    "preferences": "Настройки аккаунта",
    "payments": "Платежи",
    "settings": "Настройки приложения",
    "pricing-plans": "Тарифные планы",
    "payment-methods": "Способы оплаты",
    "recover-password": "Восстановить пароль",
    "recover-password-email": "Восстановить пароль по электронной почте",
    "404": "404",
    "faq": "FAQ",
    "users": "Пользователи",
    "admins": "Админы",
    "roles": "Роли",
    "game": "Статистика посещений",
    "shop": "Настройки магазина",
    "notifications": "Настройки уведомлений",
    "projects": "Проекты",
    "comments": "Комментарии",
    "logs": "Логи"
  },
  "messages": {
    "all": "Просмотреть все сообщения",
    "new": "Новое сообщение от {name}",
    "mark_as_read": "Пометить как прочитанное"
  },
  "navbar": {
    "messageUs": "Запросы на веб-разработку:",
    "repository": "GitHub репозиторий"
  },
  "notifications": {
    "all": "Просмотреть все",
    "less": "Свернуть",
    "mark_as_read": "Пометить как прочитанное",
    "sentMessage": "отправил вам сообщение",
    "uploadedZip": "загрузил новый Zip-файл с {type}",
    "startedTopic": "начал новую тему"
  },
  "user": {
    "language": "Сменить язык",
    "logout": "Выйти",
    "profile": "Профиль",
    "settings": "Настройки",
    "billing": "Счета",
    "faq": "FAQ",
    "helpAndSupport": "Поддержка",
    "projects": "Проекты",
    "account": "Аккаунт",
    "explore": "Исследовать"
  },
  "treeView": {
    "basic": "Основной",
    "icons": "Иконки",
    "selectable": "Выбираемый",
    "editable": "Редактируемый",
    "advanced": "Продвинутый"
  },
  "chat": {
    "title": "Чат",
    "sendButton": "Отправить"
  },
  "spacingPlayground": {
    "value": "Значение",
    "margin": "Прибыль",
    "padding": "Набивка"
  },
  "spacing": {
    "title": "Расстояние"
  },
  "cards": {
    "cards": "Карты",
    "fixed": "Исправлено",
    "floating": "Плавающий",
    "contentText": "The unique stripes of zebras make them one of the animals most familiar to people.",
    "contentTextLong": "The unique stripes of zebras make them one of the animals most familiar to people. They occur in a variety of habitats, such as grasslands, savannas, woodlands, thorny scrublands, mountains, and coastal hills. Various anthropogenic factors have had a severe impact on zebra populations, in particular hunting for skins and habitat destruction. Grévy's zebra and the mountain zebra are endangered. While plains zebras are much more plentiful, one subspecies, the quagga.",
    "rowHeight": "Высота ряда",
    "title": {
      "default": "По умолчанию",
      "withControls": "С элементами управления",
      "customHeader": "Пользовательский заголовок",
      "withoutHeader": "Без заголовка",
      "withImage": "С изображением",
      "withTitleOnImage": "С названием на изображении",
      "withCustomTitleOnImage": "С пользовательским названием на изображении",
      "withStripe": "С stripe",
      "withBackground": "С фоном"
    },
    "button": {
      "main": "Основной",
      "cancel": "Отменить",
      "showMore": "Показать больше",
      "readMore": "Показать больше"
    },
    "link": {
      "edit": "Редактировать",
      "setAsDefault": "Установить по умолчанию",
      "delete": "Удалить",
      "traveling": "Путешествие",
      "france": "Франция",
      "review": "Обзор",
      "feedback": "Оставить отзыв",
      "readFull": "Читать полностью",
      "secondaryAction": "Вторичное действие",
      "action1": "Действие 1",
      "action2": "Действие 2"
    }
  },
  "colors": {
    "themeColors": "Цвета темы",
    "extraColors": "Дополнительные цвета",
    "gradients": {
      "basic": {
        "title": "Градиенты кнопок"
      },
      "hovered": {
        "title": "Градиенты кнопок при наведении",
        "text": "Осветление на 15% применяется к оригинальному стилю (градиенту или плоскому цвету) для состояния наведения."
      },
      "pressed": {
        "title": "Градиенты кнопок при нажатии",
        "text": "Затемнение на 15% применяется к оригинальному стилю (градиенту или плоскому цвету) для состояния нажатия."
      }
    }
  },
  "tabs": {
    "alignment": "Выравнивание вкладок",
    "overflow": "Переполнение вкладок",
    "hidden": "Вкладки с скрытым слайдером",
    "grow": "Вкладки растягиваются"
  },
  "helpAndSupport": "Помощь и поддержка",
  "aboutVuesticAdmin": "О Neon Admin",
  "supportAndConsulting": "Поддержка и консультации",
  "search": {
    "placeholder": "Поиск..."
  },
  "buttonSelect": {
    "dark": "Темная",
    "light": "Светлая"
  },
  "vuestic": {
    "search": "Поиск",
    "noOptions": "Элементы не найдены",
    "ok": "ОК",
    "cancel": "Отмена",
    "uploadFile": "Загрузить файл",
    "undo": "Отменить",
    "dropzone": "Перетащите файлы сюда для загрузки",
    "fileDeleted": "Файл удален",
    "closeAlert": "закрыть оповещение",
    "backToTop": "вернуться наверх",
    "toggleDropdown": "переключить выпадающее меню",
    "carousel": "карусель",
    "goPreviousSlide": "перейти к предыдущему слайду",
    "goNextSlide": "перейти к следующему слайду",
    "goSlide": "перейти к слайду {index}",
    "slideOf": "слайд {index} из {length}",
    "close": "закрыть",
    "openColorPicker": "открыть палитру цветов",
    "colorSelection": "выбор цвета",
    "colorName": "цвет {color}",
    "decreaseCounter": "уменьшить счетчик",
    "increaseCounter": "увеличить счетчик",
    "selectAllRows": "выбрать все строки",
    "sortColumnBy": "сортировать столбец по {name}",
    "selectRowByIndex": "выбрать строку {index}",
    "resetDate": "сбросить дату",
    "nextPeriod": "следующий период",
    "switchView": "переключить вид",
    "previousPeriod": "предыдущий период",
    "removeFile": "удалить файл",
    "reset": "сбросить",
    "pagination": "пагинация",
    "goToTheFirstPage": "перейти на первую страницу",
    "goToPreviousPage": "перейти на предыдущую страницу",
    "goToSpecificPage": "перейти на страницу {page}",
    "goToSpecificPageInput": "введите номер страницы для перехода",
    "goNextPage": "перейти на следующую страницу",
    "goLastPage": "перейти на последнюю страницу",
    "currentRating": "текущий рейтинг {value} из {max}",
    "voteRating": "голосовать за рейтинг {value} из {max}",
    "optionsFilter": "фильтр опций",
    "splitPanels": "разделить панели",
    "movePaginationLeft": "переместить пагинацию влево",
    "movePaginationRight": "переместить пагинацию вправо",
    "resetTime": "сбросить время",
    "closeToast": "закрыть уведомление",
    "selectedOption": "Выбранная опция",
    "noSelectedOption": "Опция не выбрана",
    "breadcrumbs": "хлебные крошки",
    "counterValue": "значение счетчика",
    "selectedDate": "выбранная дата",
    "selectedTime": "выбранное время",
    "progressState": "состояние прогресса",
    "color": "цвет",
    "next": "Далее",
    "back": "Назад",
    "finish": "Завершить",
    "step": "шаг",
    "progress": "прогресс",
    "loading": "Загрузка",
    "sliderValue": "Текущее значение слайдера {value}",
    "switch": "Переключатель",
    "inputField": "Поле ввода",
    "fileTypeIncorrect": "Неверный тип файла",
    "select": "Выберите опцию"
  }
}
